import axios from "../../../../../../../api/axiosInstance";
import { FetchEventNotificationResponse } from "./types";

export const fetchEventNotification = async (
  id: number,
): Promise<FetchEventNotificationResponse> => {
  const response = await axios.get<FetchEventNotificationResponse>(
    `/api/private/administration/events/notifications/${id}`,
  );

  return response.data;
};
